import { render, staticRenderFns } from "./exportProducts.vue?vue&type=template&id=2af7b1ab&"
import script from "./exportProducts.vue?vue&type=script&lang=ts&"
export * from "./exportProducts.vue?vue&type=script&lang=ts&"
import style0 from "./exportProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports